import React from "react";
import { Link } from "react-router-dom";
import { fileUrl, formatFCFA } from "@/lib/api";

function StockBadge({ product }) {
  if (product.is_new && product.stock > 3) {
    return (
      <span className="absolute top-4 left-4 bg-[#B8860B] text-[#0A0A0A] text-[10px] px-2 py-1 uppercase tracking-widest font-semibold z-10">
        Nouveauté
      </span>
    );
  }
  if (product.stock === 0) {
    return (
      <span className="absolute top-4 left-4 bg-[#7F1D1D] text-white text-[10px] px-2 py-1 uppercase tracking-widest z-10">
        Rupture
      </span>
    );
  }
  if (product.stock <= 1) {
    return (
      <span className="absolute top-4 left-4 bg-red-900/95 text-white text-[10px] px-2 py-1 uppercase tracking-widest border border-red-500/30 z-10">
        Rupture imminente
      </span>
    );
  }
  if (product.stock <= 3) {
    return (
      <span className="absolute top-4 left-4 bg-red-900/90 text-white text-[10px] px-2 py-1 uppercase tracking-widest border border-red-500/30 z-10">
        Dernières pièces
      </span>
    );
  }
  return null;
}

function FavoriteBadge() {
  return (
    <div
      className="absolute top-0 right-4 z-20"
      data-testid="favorite-badge"
      aria-label="Coup de cœur du mois"
    >
      <div className="relative bg-gradient-to-b from-[#FFE9A6] to-[#D4AF37] text-[#0A0A0A] px-2 pt-2 pb-3 shadow-lg">
        <div className="text-[15px] leading-none text-center">★</div>
        <div className="mt-1 text-[8px] uppercase tracking-[0.2em] font-bold text-center leading-tight whitespace-nowrap">
          Coup<br />de cœur
        </div>
        {/* ribbon notch */}
        <div className="absolute -bottom-2 left-0 w-0 h-0 border-t-[8px] border-t-[#D4AF37] border-l-[14px] border-l-transparent" />
        <div className="absolute -bottom-2 right-0 w-0 h-0 border-t-[8px] border-t-[#D4AF37] border-r-[14px] border-r-transparent" />
      </div>
    </div>
  );
}

export default function ProductCard({ product }) {
  const photo = product.photos?.[0]?.path;
  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group flex flex-col h-full"
    >
      <div className="aspect-[4/5] overflow-hidden relative bg-[#FAF7F0]">
        <StockBadge product={product} />
        {product.is_favorite && <FavoriteBadge />}
        {photo ? (
          <img
            src={fileUrl(photo)}
            alt={product.name}
            className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-700 ease-out"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#B8860B]/40 text-5xl font-display">
            ✟
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <div className="label-tiny text-[10px]" data-testid={`product-category-${product.id}`}>
          {product.category}
        </div>
        <h3 className="font-display text-lg lg:text-xl text-[#1A1A1A] mt-2 leading-tight">
          {product.name}
        </h3>
        <p className="text-xs text-[#6B6B6B] mt-1 line-clamp-1">{product.material}</p>
        <div className="mt-auto pt-4 flex items-end justify-between">
          <div className="text-[#B8860B] font-medium" data-testid={`product-price-${product.id}`}>
            {formatFCFA(product.price)}
          </div>
          <span className="text-[10px] uppercase tracking-widest text-[#6B6B6B] group-hover:text-[#B8860B] transition-colors">
            Voir →
          </span>
        </div>
      </div>
    </Link>
  );
}
